import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ButtonSecondary from '@components/atoms/buttons/ButtonSecondary';
import iconAward from '@assets/icons/award.svg';

const Statistic = ({
	modifiers,
	className,
	value,
	text,
	awards,
	link,
	...otherProps
}) => {
	const baseClass = 'statistic';

	const rootClass = cx(baseClass, className, {
		[`${baseClass}--${modifiers}`]: modifiers,
	});

	return (
		<div className={rootClass} {...otherProps}>
			<div className="statistic__info">
				<p className="statistic__value">{value}</p>
				<p className="statistic__text">{text}</p>
			</div>
			{awards && awards.length > 0 && (
				<>
					<div className="statistic__icon">
						<svg className="icon" role="img" aria-label="Award">
							<use xlinkHref={`#${iconAward.id}`} />
						</svg>
					</div>
					<ul className="statistic__awards">
						{awards.map((award, index) => {
							return <li key={`award-${index}`}>{award}</li>;
						})}
					</ul>
				</>
			)}
			{link && (
				<ButtonSecondary
					href={link.url}
					text={link.title}
					data-target
				/>
			)}
		</div>
	);
};

Statistic.propTypes = {
	modifiers: PropTypes.string,
	className: PropTypes.string,
	value: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	link: PropTypes.object,
	awards: PropTypes.array,
};

export default Statistic;
